"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axleInformationTypes = exports.orderTypes = exports.itemListSteps = exports.filterOperators = exports.filterDefaults = exports.getTodayDate = exports.filterTypes = void 0;

var _sbStructuredFilterUtils = require("./sb-structured-filter-utils");

/**
 * Possible types of filters.
 * @type {{ENUM: string, RANGE: string, TEXT: string, FULL_TEXT: string}}
 */
var filterTypes = {
  DATE: 'date',
  ENUM: 'enum',
  RANGE: 'range',
  TEXT: 'text',
  FULL_TEXT: 'full_text'
};
exports.filterTypes = filterTypes;

var getTodayDate = function getTodayDate() {
  var midnight = new Date();
  midnight.setHours(0);
  midnight.setMinutes(0);
  midnight.setSeconds(0);
  midnight.setMilliseconds(0);
  return midnight;
};

exports.getTodayDate = getTodayDate;

var filterDefaults = function filterDefaults(dateProps) {
  var formatOutput = dateProps.formatOutput,
      format = dateProps.format,
      timeZone = dateProps.timeZone,
      locale = dateProps.locale;
  var dateTimeFormat = (0, _sbStructuredFilterUtils.getDateTimeFormat)({
    format: format,
    locale: locale,
    timeZone: timeZone
  });
  return {
    ENUM: 0,
    RANGE: {
      from: 0,
      to: 0
    },
    TEXT: '',
    FULL_TEXT: '',
    DATE: {
      from: getTodayDate(),
      to: new Date(),
      fromText: formatOutput({
        value: getTodayDate(),
        format: dateTimeFormat
      }),
      toText: formatOutput({
        value: new Date(),
        format: dateTimeFormat
      })
    }
  };
};
/**
 * Default operators
 * @type {{AND: string, OR: string}}
 */


exports.filterDefaults = filterDefaults;
var filterOperators = {
  AND: 'AND',
  OR: 'OR'
};
/**
 * Possible steps on the popup.
 * @type {{FIRST: string, SECOND: string, OPERATORS: string}}
 */

exports.filterOperators = filterOperators;
var itemListSteps = {
  FIRST: '1',
  SECOND: '2',
  OPERATORS: '0'
};
/**
 * Order types.
 * @type {{AND: string, OR: string}}
 */

exports.itemListSteps = itemListSteps;
var orderTypes = {
  ASC: 0,
  DESC: 1
};
/**
 * Axle information types.
 * @type {{FULL: string, BRIEF: string}}
 */

exports.orderTypes = orderTypes;
var axleInformationTypes = {
  FULL: 'full',
  BRIEF: 'brief'
};
exports.axleInformationTypes = axleInformationTypes;
//# sourceMappingURL=sb-structured-filter-constants.js.map